import { useRouter } from "next/router";
import { useEffect } from "react";
import useFeatureFlags from "@/hooks/common/useFeatureFlags";

export default function RedirectVisitToAppt() {
  const router = useRouter();
  const { newAppointmentModelEnabled } = useFeatureFlags();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (!newAppointmentModelEnabled) return;

      const [pathname, queryParams = ""] = url.split("?");
      if (!pathname.includes("/visits")) return;

      const redirected = pathname.replace(
        /(^|\/)visits(\/|$)/,
        "$1appointments$2"
      );
      router.replace(queryParams ? `${redirected}?${queryParams}` : redirected);
    };

    // Check redirect on initial load
    handleRouteChange(router.asPath);

    router.events.on("routeChangeStart", handleRouteChange);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [newAppointmentModelEnabled, router]);

  return null;
}
